import { get, orderBy } from 'lodash/fp'

import { ICompany } from '../interfaces'

export const sortOffice: (items: ICompany[]) => ICompany[] = orderBy<ICompany>(
  ['isMain', 'priority', get('address.city'), get('address.street')],
  ['desc', 'asc', 'asc', 'asc']
)
